<template>
  <i-select :value="value" :filterable="true" :clearable="true" @input="on_select">
    <i-option
      v-for="option in external_numbers"
      :key="option.id"
      :value="option.id"
      :label="option.number"
    />
  </i-select>
</template>

<script>
  import { NumberService } from '@pbx/services/NumberService';

  export default {
    props: {
      value: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        numbers: [],
        external_numbers: []
      };
    },

    created() {
      const is_external = number_item => number_item.type === 'external';

      NumberService.getForScheme()
        .then(numbers =>
          numbers.map(number => {
            if (number.id === this.value && number.type === 'external') {
              return { ...number, used: false };
            }

            return number;
          })
        )
        .then(numbers => {
          this.numbers = numbers;
          this.external_numbers = numbers.filter(number => is_external(number));
        });
    },

    methods: {
      on_select: function(value = null) {
        this.$emit('input', value);
      }
    }
  };
</script>
